export default {
    title: 'Titel and description',
    tooltip: 'Edit title and description'
}
